import { render, staticRenderFns } from "./scientific-management.vue?vue&type=template&id=cfa5c8bc&scoped=true"
import script from "./scientific-management.vue?vue&type=script&lang=ts"
export * from "./scientific-management.vue?vue&type=script&lang=ts"
import style0 from "./scientific-management.vue?vue&type=style&index=0&id=cfa5c8bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa5c8bc",
  null
  
)

export default component.exports